import './navigation.js';
import './skip-link-focus-fix.js';
import './myloadmore.js'

(( $ ) => {


	$(document).ready( () => {

		if ($(window).width() > 960) {
		/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
			var prevScrollpos = window.pageYOffset ;
			window.onscroll = function() {
				 if($(this).scrollTop() > 100) {
				  var currentScrollPos = window.pageYOffset;
				  if (prevScrollpos >= currentScrollPos) {
				    $("#masthead").css('top', "0");


				  } else {
				    $("#masthead").css('top', "-90px");


						if ($('.helper-scroll').length) {
							gsap.to('.helper-scroll', {opacity: 0, duration: 3});
						}
				  }
				  prevScrollpos = currentScrollPos;
				}
			}
		}

		// accessibility/layout settings

			var fontSize = sessionStorage.getItem('font');


			// change font size based on screen size

			 if ($(window).width() > 1440) {

				 if (fontSize == 'lg') {
					 $(':root').css('font-size', '18px');
						$('.btn-font-lg').addClass('active');

					} else if (fontSize == 'sm') {
						$('.btn-font-sm').addClass('active');
					 $(':root').css('font-size', '14px');

					} else {
						$('.btn-font-md').addClass('active');
					}


				 $('.btn-font-sm').click(function(){
					 $(':root').css('font-size', '14px');
					 $('.btn-font').removeClass('active');
					 $(this).addClass('active');

					 sessionStorage.setItem('font', 'sm');
				 });

				 $('.btn-font-md').click(function(){
					 $(':root').css('font-size', '16px');
					 $('.btn-font').removeClass('active');
						 $(this).addClass('active');

						 sessionStorage.setItem('font', 'md');
				 });

				 $('.btn-font-lg').click(function(){
					 $(':root').css('font-size', '18px');
						 $('.btn-font').removeClass('active');
						 $(this).addClass('active');

						 sessionStorage.setItem('font', 'lg');
				 });


			 } else if ($(window).width() > 1280) {


				 if (fontSize == 'lg') {
					$(':root').css('font-size', '16px');
					 $('.btn-font-lg').addClass('active');

				 } else if (fontSize == 'sm') {
					 $('.btn-font-sm').addClass('active');
					$(':root').css('font-size', '12px');

				 } else {
					 $('.btn-font-md').addClass('active');
				 }

				 $('.btn-font-sm').click(function(){
					$(':root').css('font-size', '12px');
					$('.btn-font').removeClass('active');
					$(this).addClass('active');

					sessionStorage.setItem('font', 'sm');
				});

				$('.btn-font-md').click(function(){
					$(':root').css('font-size', '14px');
					$('.btn-font').removeClass('active');
						$(this).addClass('active');

						sessionStorage.setItem('font', 'md');
				});

				$('.btn-font-lg').click(function(){
					$(':root').css('font-size', '16px');
						$('.btn-font').removeClass('active');
						$(this).addClass('active');

						sessionStorage.setItem('font', 'lg');
				});

			} else {

								 if (fontSize == 'lg') {
									$(':root').css('font-size', '15px');
									 $('.btn-font-lg').addClass('active');

								 } else if (fontSize == 'sm') {
									 $('.btn-font-sm').addClass('active');
									$(':root').css('font-size', '12px');

								 } else {
									 $('.btn-font-md').addClass('active');
								 }

								 $('.btn-font-sm').click(function(){
									$(':root').css('font-size', '12px');
									$('.btn-font').removeClass('active');
									$(this).addClass('active');

									sessionStorage.setItem('font', 'sm');
								});

								$('.btn-font-md').click(function(){
									$(':root').css('font-size', '13px');
									$('.btn-font').removeClass('active');
										$(this).addClass('active');

										sessionStorage.setItem('font', 'md');
								});

								$('.btn-font-lg').click(function(){
									$(':root').css('font-size', '15px');
										$('.btn-font').removeClass('active');
										$(this).addClass('active');

										sessionStorage.setItem('font', 'lg');
								});


			}





		var bgColor = sessionStorage.getItem('bg');

		if (bgColor == 'dark') {
			 $('body').addClass('body-dark');
			 $('#btn-black').addClass('active-bg');

		 } else if (bgColor == 'green') {
			 $('#btn-green').addClass('active-bg');
		 	$('body').addClass('bg-green-50');

		 } else {
			 $('#btn-white').addClass('active-bg');
		 }

		$('#btn-white').click(function(){
			$('body').removeClass('bg-green-50');
			$('body').removeClass('body-dark');

			sessionStorage.setItem('bg', 'normal');

			$('.btn-color').removeClass('active-bg');
			$(this).addClass('active-bg');

		});

		$('#btn-green').click(function(){
			$('body').removeClass('body-dark');
			$('body').addClass('bg-green-50');

			$('.btn-color').removeClass('active-bg');
			$(this).addClass('active-bg');

			sessionStorage.setItem('bg', 'green');

		});

		$('#btn-black').click(function(){
			$('body').removeClass('bg-green-50');
			$('body').addClass('body-dark');

			$('.btn-color').removeClass('active-bg');
			$(this).addClass('active-bg');

			sessionStorage.setItem('bg', 'dark');

		});




		// show search form on click
		$('#search-btn').click(function(){
			$('#search-form').slideToggle(200);

		});

		// show settings form on click
		$('#show-settings').click(function(){
			$('#layout-settings').slideToggle(200);

		});



		$('.exit').click(function(){
			$('#search-form').slideUp();
			$('#layout-settings').slideUp();

		});


			$('#toggleFilter').click(function(){

			});


		// smooth scrolling

			$('a[href^="#"]').bind('click', function(e) {
					e.preventDefault(); // prevent hard jump, the default behavior

					var target = $(this).attr("href"); // Set the target as variable

					// perform animated scrolling by getting top-position of target-element and set it as scroll target
					$('html, body').stop().animate({
							scrollTop: $(target).offset().top
					}, 600, function() {
							location.hash = target; //attach the hash (#jumptarget) to the pageurl
					});

					return false;
			});


			// open menu on click
			$('#menu-toggle').click(function(){
				gsap.set('#site-menu', {display:'flex'})
				gsap.fromTo('#site-menu', { x: 2000, opacity: 0}, {duration: 0.5, opacity: 1, x: 0, ease:Power2.easeOut});

			});
			$('#menu-close').click(function(){

				gsap.fromTo('#site-menu', { x: 0}, {duration: 0.75, x: 2000, ease:Power2.easeInOut, opacity: 0});
				gsap.to('#site-menu', {display:'none', duration: 1});
			});



				// show modal on click
				$('.btn-modal').click(function () {
					gsap.set('.modal', {display:'block'});
					gsap.fromTo('.modal', { x: 2000, opacity: 0}, {duration: 0.5, opacity: 1, x: 0, ease:Power2.easeOut});
				});

				// event_closing_time modal on click
				$('.btn-modal-close').click(function () {
							gsap.to('.modal', {display:'none', duration: 1});
							gsap.fromTo('.modal', { x: 0, opacity: 1}, {duration: 0.8, opacity: 0, x: 2000, ease:Power2.easeOut});
				});

				// scroll down animation
				if ($('.helper-scroll').length) {

					gsap.fromTo('.footstep, .scroll-text', { opacity: 0}, {duration: 1, opacity: 1, ease:Power2.easeInOut, stagger: 0.5, delay: 2});
				}


				// horizontal scroll dragging functionality
				$('.drag-scroll-x .event-items').mouseenter(function(){
					// $(this).css('background', '#000');
				const slider = this;
				let isDown = false;
				let startX;
				let scrollLeft;

				var cards = $(this).find('.event-card');
				if (cards.length > 1) {

					slider.addEventListener('mousedown', (e) => {
					  isDown = true;
					  slider.classList.add('active');
					  startX = e.pageX - slider.offsetLeft;
					  scrollLeft = slider.scrollLeft;
					});
					slider.addEventListener('mouseleave', () => {
					  isDown = false;
					  slider.classList.remove('active');
					});
					slider.addEventListener('mouseup', () => {
					  isDown = false;
					  slider.classList.remove('active');
					});
					slider.addEventListener('mousemove', (e) => {
					  if(!isDown) return;
					  e.preventDefault();
					  const x = e.pageX - slider.offsetLeft;
					  const walk = (x - startX) * 1; //scroll-fast
					  slider.scrollLeft = scrollLeft - walk;
					  console.log(walk);
					});
			}

			});

	});





	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js